<ion-content color="lightmimbo">
  <div class="ion-text-center" style="padding-top: 16px !important" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-grid *ngIf="!isLoading">
    <ion-row>
      <ion-col>
        <div class="fact-container">
          <h3> 🐾 Paw Fact of the Day 🐾 </h3>
          <div class="fact-image"></div>


          <h6>{{factDate}}</h6>
          <div class="fact">{{fact.fact}}</div>
          <div class="buttons">
            <button class="btn" [disabled]="!fact.hasPrevious" [ngClass]="{'disabled': fact.hasPrevious === false}"
              (click)="getFact(false)">
              Previous Fact
            </button>
            <button class="btn" [disabled]="!fact.hasNext" [ngClass]="{'disabled': fact.hasNext === false}"
              (click)="getFact(true)">
              Next Fact
            </button>
          </div>

        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>